import { CONTENT_TYPES, getResourceContentType } from '@/utils/content-type';
import { Resource } from '@edwin-group/cj-graphql';
import PodcastCard from './Podcast';
import GenericResourceCard from './GenericResource';

const ResourceCard = ({
  resource,
  showBookmarkIcon,
  buttonText = 'Learn more',
  onRemoveFromBookmark,
}: {
  resource: Resource;
  showBookmarkIcon?: boolean;
  buttonText?: string;
  onRemoveFromBookmark?: () => void;
}) => {
  const type = getResourceContentType(resource?.resourceType?.type);

  if (type === CONTENT_TYPES.PODCAST) {
    return (
      <PodcastCard
        resource={resource}
        showBookmarkIcon={showBookmarkIcon}
        onRemoveFromBookmark={onRemoveFromBookmark}
        buttonText={buttonText}
      />
    );
  }

  return (
    <GenericResourceCard
      resource={resource}
      showBookmarkIcon={showBookmarkIcon}
      onRemoveFromBookmark={onRemoveFromBookmark}
      buttonText={buttonText}
    />
  );
};

export default ResourceCard;
